import { render } from "./pagos.vue?vue&type=template&id=33125e04"
import script from "./pagos.vue?vue&type=script&lang=js"
export * from "./pagos.vue?vue&type=script&lang=js"
script.render = render

export default script